import MusicNoteSVG from "@src/assets/img/music-note.svg";
import { theme } from "@src/theme";

const ArtWorkImage = ({
  $compressedUI,
  value,
  ImgStyle,
  customSize,
}: {
  $compressedUI?: boolean;
  value: string;
  ImgStyle?: React.CSSProperties;
  customSize?: string;
}): React.JSX.Element => {
  if (value) {
    return (
      <img
        src={value}
        style={{
          width: customSize ? customSize : $compressedUI ? "40px" : "60px",
          height: customSize ? customSize : $compressedUI ? "40px" : "60px",
          objectFit: "cover",
          borderRadius: theme.margins.small,
          transition: "width 0.3s, height 0.3s",
          ...ImgStyle,
        }}
      />
    );
  }
  return (
    <img
      src={MusicNoteSVG}
      style={{
        backgroundColor: value ? "transparent" : theme.colors.yellow,
        width: customSize ? customSize : $compressedUI ? "40px" : "60px",
        height: customSize ? customSize : $compressedUI ? "40px" : "60px",
        objectFit: !value ? "scale-down" : "contain",
        borderRadius: theme.margins.small,
        transition: "width 0.3s, height 0.3s",
        ...ImgStyle,
      }}
    />
  );
};
export default ArtWorkImage;
